import { Page } from './../models/page';
import { AuthenticationService } from './authentication.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable} from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';


@Injectable()
export class PageService {

  constructor(private http: HttpClient, private authService : AuthenticationService) {}

  private getHeaderWithToken() : HttpHeaders {
    return new HttpHeaders({
      'authorization': 'Bearer ' + this.authService.getToken(),
      'reportProgress' : 'true',
      'observe' : 'events'
    });
  }

  save(page: Page): Observable<Page> {
    return this.http.post<Page>(environment.serverUrl + 'api/page/', page, { headers: this.getHeaderWithToken() });
  }

  get(id : number) : Observable<Page> {
    return this.http.get<Page>(environment.serverUrl + 'api/page/' + id, { headers: this.getHeaderWithToken() });
  }

  delete(id : number) : Observable<{}> {
    return this.http.delete<Page>(environment.serverUrl + 'api/page/' + id, { headers: this.getHeaderWithToken() });
  }

  getAll() : Observable<Page[]> {
    return this.http.get<Page[]>(environment.serverUrl + 'api/page/list/', { headers: this.getHeaderWithToken() });
  }

  getAllHome() : Observable<Page[]> {
    return this.http.get<Page[]>(environment.serverUrl + 'api/page/listHome', { headers: this.getHeaderWithToken() });
  }

  getByName(name : string) : Observable<Page> {
    return this.http.get<Page>(environment.serverUrl + 'api/page/name/' + name + '/content/', { headers: this.getHeaderWithToken() });
  }
}
